import { EmbroideryObjects } from 'src/types'

export const typeFaceObjs = [
  { label: '漢字', value: 'serif' }, // 明朝体
  { label: '活字体', value: 'sans-serif' }, //ゴシック体
  { label: '筆記体', value: 'Zapfino, cursive' }, // 筆記体
  { label: 'ブラッシュ体', value: 'Brush Script MT' }
]
export const typeFaceJaObjs = typeFaceObjs.filter((t) => ['serif'].some((f) => f === t.value))
export const typeFaceEnObjs = typeFaceObjs.filter((t) => 'serif' !== t.value)

export const positionObjs = [
  { label: '親指部分', value: 'thumbFinger' },
  { label: '小指部分', value: 'childFinger' },
  { label: '裏革部分(1段目)', value: 'leatherLiningFirst' },
  { label: '裏革部分(2段目)', value: 'leatherLiningSecond' }
  // { label: 'グラブ袋', value: 'gloveBag' }
]

export const FIRST_MITT_POSITION_OPTIONS = [
  { label: '親指部分', value: 'thumbFinger' },
  { label: '小指側背面', value: 'pinkyFingerSideBack' },
  { label: '裏革部分(1段目)', value: 'leatherLiningFirst' },
  { label: '裏革部分(2段目)', value: 'leatherLiningSecond' }
]

const ALL_POSITIONS = [
  { label: '親指部分', value: 'thumbFinger' },
  { label: '小指部分', value: 'childFinger' },
  { label: '小指側背面', value: 'pinkyFingerSideBack' },
  { label: '裏革部分(1段目)', value: 'leatherLiningFirst' },
  { label: '裏革部分(2段目)', value: 'leatherLiningSecond' }
]

export const colorObjs = [
  { label: 'ゴールド', value: 'gold', color: '#D9A948' },
  { label: 'シルバー', value: 'silver', color: '#A7A8A7' },
  { label: 'ライトゴールド', value: 'lightGold', color: '#D7B070' },
  { label: 'ライトシルバー', value: 'lightSilver', color: '#DFDAD4' },
  { label: 'コルク', value: 'kurk', color: '#A18555' },
  { label: 'チョコレート', value: 'chocolate', color: '#6F4A35' },
  { label: 'イエロー', value: 'yellow', color: '#F3CD54' },
  { label: 'レモンイエロー', value: 'lemonYellow', color: '#FFF059' },
  { label: 'オレンジ', value: 'orange', color: '#CF7D43' },
  { label: 'レッド', value: 'red', color: '#A03D38' },
  { label: 'ピンク', value: 'pink', color: '#DE949A' },
  { label: 'パープル', value: 'purple', color: '#754F6E' },
  { label: 'グリーン', value: 'green', color: '#719B4F' },
  { label: 'スカイブルー', value: 'skyBlue', color: '#0096C9' },
  { label: 'ブルー', value: 'royalBlue', color: '#305173' },
  { label: 'ネイビー', value: 'navy', color: '#2C3F67' },
  { label: 'ブラック', value: 'black', color: '#1A1919' },
  { label: 'ホワイト', value: 'white', color: '#F6F3F0' }
]

export const shadowEdgeColorObjs = [{ label: '不要', value: 'none' }, ...colorObjs]

export const gorillaObjects: EmbroideryObjects = {
  typeFace: typeFaceObjs,
  position: ALL_POSITIONS,
  color: colorObjs,
  shadowColor: shadowEdgeColorObjs,
  edgeColor: shadowEdgeColorObjs
}
